
export const customertypes = (state, value) => {
  state.customertypes = value
}
export const activecustomertypes = (state, value) => {
  state.activecustomertypes = value
}
export const jobtitles = (state, value) => {
  state.jobtitles = value
}
export const activejobtitles = (state, value) => {
  state.activejobtitles = value
}
export const salutations = (state, value) => {
  state.salutations = value
}
export const activesalutations = (state, value) => {
  state.activesalutations = value
}
export const regions = (state, value) => {
  state.regions = value
}
export const activeregions = (state, value) => {
  state.activeregions = value
}
export const mbpbranches = (state, value) => {
  state.mbpbranches = value
}
export const activembpbranches = (state, value) => {
  state.activembpbranches = value
}
export const salesexecs = (state, value) => {
  state.salesexecs = value
}
export const activesalesexecs = (state, value) => {
  state.activesalesexecs = value
}
export const opportunitystatuses = (state, value) => {
  state.opportunitystatuses = value
}
export const activeOpportunityStatuses = (state, value) => {
  state.activeOpportunityStatuses = value
}
export const quotestatuses = (state, value) => {
  state.quotestatuses = value
}
export const activequotestatuses = (state, value) => {
  state.activequotestatuses = value
}
export const activitystatuses = (state, value) => {
  state.activitystatuses = value
}
export const activeactivitystatuses = (state, value) => {
  state.activeactivitystatuses = value
}
export const activityTypes = (state, value) => {
  state.activityTypes = value
}
export const activeactivitytypes = (state, value) => {
  state.activeactivitytypes = value
}
export const activeremindertypes = (state, value) => {
  state.activeremindertypes = value
}
export const activityresults = (state, value) => {
  state.activityresults = value
}
export const activeactivityresults = (state, value) => {
  state.activeactivityresults = value
}
export const producttypes = (state, value) => {
  state.producttypes = value
}
export const activeproducttypes = (state, value) => {
  state.activeproducttypes = value
}
export const projecttypes = (state, value) => {
  state.projecttypes = value
}
export const activeprojecttypes = (state, value) => {
  state.activeprojecttypes = value
}
export const lostquotenotes = (state, value) => {
  state.lostquotenotes = value
}
export const activelostquotenotes = (state, value) => {
  state.activelostquotenotes = value
}
export const datemodifiers = (state, value) => {
  state.datemodifiers = value
}
export const users = (state, value) => {
  state.users = value
}
export const activeusers = (state, value) => {
  state.activeusers = value
}
export const citiesTowns = (state, value) => {
  state.citiesTowns = value
}
export const activeCitiesTowns = (state, value) => {
  state.activeCitiesTowns = value
}
export const roles = (state, value) => {
  state.roles = value
}
export const activeRoles = (state, value) => {
  state.activeRoles = value
}
export const favoriteFilters = (state, value) => {
  state.favoriteFilters = value
}
export const jobfunctions = (state, value) => {
  state.jobfunctions = value
}
export const mbpDepartments = (state, value) => {
  state.mbpDepartments = value
}
export const quotationGrades = (state, value) => {
  state.quotationGrades = value
}
export const activeQuotationGrades = (state, value) => {
  state.activeQuotationGrades = value
}
export const userWidgets = (state, value) => {
  state.userWidgets = value
}
export const opportunities = (state, value) => {
  state.opportunities = value
}
export const mbpdepts = (state, value) => {
  state.mbpdepts = value
}
export const contacttypes = (state, value) => {
  state.contacttypes = value
}
export const activequotations = (state, value) => {
  state.activequotations = value
}
export const parentcustomernames = (state, value) => {
  state.parentcustomernames = value
}
export const contacts = (state, value) => {
  state.contacts = value
}
export const customernames = (state, value) => {
  state.customernames = value
}



export const columnsSelection1 = (state, value) => {
  state.columnsSelection1 = value
}
export const columnsSelection2 = (state, value) => {
  state.columnsSelection2 = value
}
export const columnsSelection3 = (state, value) => {
  state.columnsSelection3 = value
}
export const columnsSelection4 = (state, value) => {
  state.columnsSelection4 = value
}
export const columnsSelection5 = (state, value) => {
  state.columnsSelection5 = value
}
export const columnsSelection6 = (state, value) => {
  state.columnsSelection6 = value
}
export const columnsSelection7 = (state, value) => {
  state.columnsSelection7 = value
}
export const columnsSelection8 = (state, value) => {
  state.columnsSelection8 = value
}
export const columnsSelection12 = (state, value) => {
  state.columnsSelection8 = value
}
export const columnsSelection13 = (state, value) => {
  state.columnsSelection13 = value
}
export const columnsSelection101 = (state, value) => {
  state.columnsSelection101 = value
}
export const columnsSelection102 = (state, value) => {
  state.columnsSelection102 = value
}


export const dbViewFields1 = (state, value) => {
  state.dbViewFields1 = value
}
export const dbViewFields2 = (state, value) => {
  state.dbViewFields2 = value
}
export const dbViewFields3 = (state, value) => {
  state.dbViewFields3 = value
}
export const dbViewFields4 = (state, value) => {
  state.dbViewFields4 = value
}
export const dbViewFields5 = (state, value) => {
  state.dbViewFields5 = value
}
export const dbViewFields6 = (state, value) => {
  state.dbViewFields6 = value
}
export const dbViewFields7 = (state, value) => {
  state.dbViewFields7 = value
}
export const dbViewFields8 = (state, value) => {
  state.dbViewFields8 = value
}
export const dbViewFields12 = (state, value) => {
  state.dbViewFields12 = value
}
export const dbViewFields13 = (state, value) => {
  state.dbViewFields13 = value
}
export const dbViewFields101 = (state, value) => {
  state.dbViewFields101 = value
}
export const dbViewFields102 = (state, value) => {
  state.dbViewFields102 = value
}


export const userViewFilters1 = (state, value) => {
  state.userViewFilters1 = value
}
export const userViewFilters2 = (state, value) => {
  state.userViewFilters2 = value
}
export const userViewFilters3 = (state, value) => {
  state.userViewFilters3 = value
}
export const userViewFilters4 = (state, value) => {
  state.userViewFilters4 = value
}
export const userViewFilters5 = (state, value) => {
  state.userViewFilters5 = value
}
export const userViewFilters6 = (state, value) => {
  state.userViewFilters6 = value
}
export const userViewFilters7 = (state, value) => {
  state.userViewFilters7 = value
}
export const userViewFilters8 = (state, value) => {
  state.userViewFilters8 = value
}
export const userViewFilters12 = (state, value) => {
  state.userViewFilters12 = value
}
export const userViewFilters13 = (state, value) => {
  state.userViewFilters13 = value
}


export const defUserViewFilter1 = (state, value) => {
  state.defUserViewFilter1 = value
}
export const defUserViewFilter2 = (state, value) => {
  state.defUserViewFilter2 = value
}
export const defUserViewFilter3 = (state, value) => {
  state.defUserViewFilter3 = value
}
export const defUserViewFilter4 = (state, value) => {
  state.defUserViewFilter4 = value
}
export const defUserViewFilter5 = (state, value) => {
  state.defUserViewFilter5 = value
}
export const defUserViewFilter6 = (state, value) => {
  state.defUserViewFilter6 = value
}
export const defUserViewFilter7 = (state, value) => {
  state.defUserViewFilter7 = value
}
export const defUserViewFilter8 = (state, value) => {
  state.defUserViewFilter8 = value
}
export const defUserViewFilter12 = (state, value) => {
  state.defUserViewFilter12 = value
}
export const defUserViewFilter13 = (state, value) => {
  state.defUserViewFilter13 = value
}
